

























import { CalculationYear } from "@/types";
import { formatCurrency } from "@/utils";
import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "CalculatorTable",
  props: {
    contingent: {
      type: Array as PropType<CalculationYear[]>,
      required: true,
    },
  },
  computed: {
    sum() {
      return this.contingent
        .map((item) => parseInt(item.ordreBelop))
        .reduce((sum, belop) => sum + belop, 0);
    },
  },
  methods: {
    convertToCurrency(num: number): string {
      return formatCurrency(num);
    },
  },
});
